function isRejectionCommingFromEdgePlatform(error: any): boolean {
    return error.status === 403 && !(error.response.headers?.get('X-Platform') === 'MALT');
}

export const UnauthorizedResponseHelper = {
    isRejectionCommingFromEdgePlatform,
};
